<script setup>
import { useRoute } from "vue-router";
import { storeToRefs } from "pinia";
import { useActiveDeviceRenderStore } from "@/stores/activeDeviceRender";
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue'

const route = useRoute();
const activeDeviceRender = useActiveDeviceRenderStore();
const {proofreadIssues} = storeToRefs(activeDeviceRender);

const props = defineProps({
  qa: {type: Boolean, default: false},
})

const tabs = ref([
  {
    label: 'Layout',
    section: 'audit',
    icon: 'fa-solid fa-tablet-screen-button',
    color: '#10b981',
    completed: true,
  },
  {
    label: 'Proofread',
    section: 'proofread',
    icon: 'fa-spell-check',
    color: '#3b82f6',
    completed: false,
  }
])
if (props.qa) {
  tabs.value.push(
      {
        label: 'Q/A',
        section: 'qa',
        icon: 'fa fa-solid fa-wand-magic-sparkles',
        color: '#3b82f6',
        completed: true,
      }
  )
}
tabs.value.push(...
    [{
      label: 'AI',
      section: 'ai_readiness',
      icon: 'fa-robot',
      color: '#ea8600',
      completed: true,
    },
      {
        label: '',
        section: 'history',
        icon: 'fa-clock-rotate-left',
        color: '#64748b',
        completed: true,
      }]
);

watch(
    [proofreadIssues, () => activeDeviceRender.loaded],
    ([issues, activeDeviceRenderLoaded]) => {
      if (!activeDeviceRenderLoaded) {
        return
      }
      let proofreadTab = tabs.value.find(v=>v.section === 'proofread')
      proofreadTab.completed = ['completed', 'error'].includes(issues.status)
      let aiReadinessTab = tabs.value.find(v=>v.section === 'ai_readiness')
      aiReadinessTab.completed = ['completed', 'error'].includes(issues.ai_readiness_status)
    },
    {
      immediate: true,
    }
)

</script>

<template>
  <div class="bg-light border-top p-1">
    <div class="d-flex gap-1">
      <router-link
          v-for="tab in tabs"
          :key="tab.section"
          :to="{ params: { deviceId: route.params.deviceId }, query: { section: tab.section } }"
          class="tab-item flex-fill text-center py-1 px-2 rounded-pill text-decoration-none"
          :class="{ 'active': (route.query.section || 'audit') === (tab.section || null),  'is-processing': !tab.completed} "
          :style="(route.query.section || 'audit') === (tab.section || null) ? { backgroundColor: tab.color, borderColor: tab.color, color: '#fff' } : {}"
      >
        <i :class="['fa fa-fw', tab.icon, 'me-1']"
           :style="{ color: (route.query.section || 'audit') === (tab.section || null) ? '#fff' : tab.color }"></i>
        <div class="tab-label">{{ tab.label }}</div>
      </router-link>
    </div>
  </div>
</template>

<style scoped>
.tab-item {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  color: #6c757d;
  font-weight: 500;
  font-size: 0.8rem;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.tab-item:hover {
  background-color: #fff;
  border-color: #dee2e6;
  transform: translateY(-1px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.tab-item.active {
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
}

.tab-label {
  font-size: 0.7rem;
  line-height: 1;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

.tab-item i {
  display: block;
  font-size: 0.9rem;
}
</style>